import CryptoJS from 'crypto-js'

// 处理小程序环境下crypto模块问题
try {
  // 尝试使用crypto-js的默认配置
  CryptoJS.lib.WordArray.random(128/8);
} catch (e) {
  // 如果出现native crypto module错误，使用纯软件实现
  console.warn('Using software-based crypto implementation');
}

// 密钥（应从安全的地方获取，这里仅为示例）
const SECRET_KEY = 'nongtou-uni-secret-key-123456'

// AES加密
export function encrypt(text) {
  try {
    // 确保传入的是字符串
    if (!text || typeof text !== 'string') {
      console.warn('Invalid text for encryption:', text)
      return ''
    }
    const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString()
    return encrypted
  } catch (error) {
    console.error('Encryption error:', error)
    // 返回空字符串而不是null，避免密码为null的情况
    return ''
  }
}

// AES解密
export function decrypt(ciphertext) {
  try {
    // 确保传入的是字符串
    if (!ciphertext || typeof ciphertext !== 'string') {
      console.warn('Invalid ciphertext for decryption:', ciphertext)
      return ''
    }
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)
    return decrypted
  } catch (error) {
    console.error('Decryption error:', error)
    // 返回空字符串而不是null
    return ''
  }
}

// MD5哈希
export function md5(text) {
  return CryptoJS.MD5(text).toString()
}

// SHA256哈希
export function sha256(text) {
  return CryptoJS.SHA256(text).toString()
}